<template>
  <md-dialog :md-closed="closeDialog" :md-opened="openDialog" class="comment-box" :md-close-on-esc="false"
             :md-click-outside-to-close="false"
             :md-active.sync="options.showaddKommentarForm">
    <md-dialog-title class="ml-30 mt-20" style="font-size: 2rem;">
      <div class="tab-header-grid">
        <div class="tab-title">
          {{ options.Lang.addKommentar +  ( openMail ? ' | ' + (form.lang === 'de' ? 'DE' : 'EN') : '' ) }}
        </div>
        <div class="tab-info-box">
          <SmallInfoBox title="Angebot" :content="trip_details_json?.data?.attributes?.alias || ''" />
        </div>

        <div class="tab-info-box">
          <SmallInfoBox :title="'Nezasa ID'" :content="trip ? trip.nezasa_id : ''" :copy="true" />
        </div>
      </div>
      <div class="tab-buttons">
        <button class="tab-btn" :class="{ active: tabChoice === 'flights', disabled: !safeFlights.length }" :disabled="!safeFlights.length" @click="onTabChange('flights')">
          <md-icon>connecting_airports</md-icon>Flights
        </button>
        <button class="tab-btn" :class="{ active: tabChoice === 'carRentals', disabled: !safeRentalCars.length }" :disabled="!safeRentalCars.length" @click="onTabChange('carRentals')">
          <md-icon>car_rental</md-icon>Car Rentals
        </button>
        <button class="tab-btn" :class="{ active: tabChoice === 'hotels', disabled: !safeHotels.length }" :disabled="!safeHotels.length" @click="onTabChange('hotels')">
          <md-icon>night_shelter</md-icon>Hotels
        </button>
        <button class="tab-btn" :class="{ active: tabChoice === 'activites', disabled: !safeActivities.length }" :disabled="!safeActivities.length" @click="onTabChange('activites')">
          <md-icon>visibility</md-icon>Activities
        </button>
        <button class="tab-btn" :class="{ active: tabChoice === 'transport', disabled: !safeShuttles.length }" :disabled="!safeShuttles.length" @click="onTabChange('transport')">
          <md-icon>directions_bus</md-icon>Transports
        </button>
      </div>
    </md-dialog-title>
    <md-dialog-content  style="display: flex; overflow: hidden;" >
      <transition name="fade-transition" mode="out-in" @before-enter="fadeBeforeEnter" @enter="fadeEnter" @after-enter="fadeAfterEnter" @before-leave="fadeBeforeLeave" @leave="fadeLeave" @after-leave="fadeAfterLeave">
        <div :key="tabChoice" class="transition-box">
          <div v-if="tabChoice === 'flights'" class="leistungen pt-30">
            <EventComments
              :EventObject="safeFlights"
              :loaded="loaded"
              :selectedIndexProp="selectedIndexesByTab.flights"
              @check-save-kommentar="checkSaveKommentar"
            />
          </div>
          <div v-else-if="tabChoice === 'carRentals'" class="leistungen pt-30">
            <EventComments
              :EventObject="safeRentalCars"
              :loaded="loaded"
              :selectedIndexProp="selectedIndexesByTab.carRentals"
              @check-save-kommentar="checkSaveKommentar"
            />
          </div>
          <div v-else-if="tabChoice === 'hotels'" class="leistungen pt-30">
            <EventComments
              :EventObject="safeHotels"
              :loaded="loaded"
              :selectedIndexProp="selectedIndexesByTab.hotels"
              @check-save-kommentar="checkSaveKommentar"
            />
          </div>
          <div v-else-if="tabChoice === 'activites'" class="leistungen pt-30">
            <EventComments
              :EventObject="safeActivities"
              :loaded="loaded"
              :selectedIndexProp="selectedIndexesByTab.activites"
              @check-save-kommentar="checkSaveKommentar"
            />
          </div>
          <div v-else-if="tabChoice === 'transport'" class="leistungen pt-30">
            <EventComments
              :EventObject="safeShuttles"
              :loaded="loaded"
              :selectedIndexProp="selectedIndexesByTab.transport"
              @check-save-kommentar="checkSaveKommentar"
            />
          </div>
          <div style="float: right; width: 60%; margin-left: 5%;" class="pt-30">
            <div class="editor-box comment-editor-box">
              <div class="editor-header comment-editor-header">
                <TextEditorWithHeader :options="options" :editor="editor" style="margin-right: 0 !important;" />
              </div>
            </div>
          </div>
        </div>
      </transition>
    </md-dialog-content>
    <md-dialog-actions class="tab-actions-border">
        <md-button tabindex="7" class="md-raised md-primary" id="sendButton" disabled @click="save">{{ options.Lang.saveKommentar }}</md-button>
        <md-button class="md-raised secondary" @click="closeDialog"><strong>{{ options.Lang.close_window }}</strong></md-button>
    </md-dialog-actions>
    <Success :options="options" v-if="succi"></Success>
    <div id="modalSave" class="md-elevation-9" v-if="modalSave">
      <p style="height: 70%; font-size: 18px; line-height: 1.5;">{{ options.Lang.warningKommi }}</p>
      <div style=" display: flex; float: right;">
        <md-button style="margin-top: -2rem;" class="md-raised secondary" @click="showKommentar"><strong>{{ options.Lang.showKommentar }}</strong></md-button>   
        <md-button style="margin-top: -2rem;" class="md-raised secondary" @click="detailsForLeistung(myDetail, myId)"><strong>{{ options.Lang.trashKommentar }}</strong></md-button>   
        <md-button style="margin-top: -2rem;" tabindex="7" class="md-raised md-primary" @click="save">{{ options.Lang.saveKommentar }}
        </md-button>
      </div>
     
    </div>
  </md-dialog>
</template>

<script>
import * as moment from "moment";
import {validationMixin} from 'vuelidate'
import {Editor, EditorContent} from '@tiptap/vue-2'
import Underline from '@tiptap/extension-underline'
import StarterKit from '@tiptap/starter-kit'
import Success from '../../components/dialogs/Success.vue'
import TextEditorBox from '../basics/TextEditorBox.vue';
import Link from "@tiptap/extension-link";
import SmallInfoBox from '../../components/parts/SmallInfoBox.vue'
import EventComments from '../../components/parts/EventComments.vue'
import TextEditorWithHeader from '../parts/TextEditorWithHeader.vue';
import fadeTransition from '../../mixins/fadeTransition.js';

import {required,} from 'vuelidate/lib/validators'

export default {
  name: 'FormAddKommentar',
  mixins: [validationMixin, fadeTransition],
  components: {
    EditorContent, Success, TextEditorBox, SmallInfoBox, EventComments, TextEditorWithHeader
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    currentTrip: {
      type: Object
    },
  },
  data: () => ({
    leistungaktiv: false,
    selectedHotelIndex: null,
    selectedCarIndex: null,
    itiDetails: null,
    trip: null,
    trip_details_json: null,
    tabChoice: 'flights',
    loaded: false,
    checkDetail: null,
    currentComp: null,
    actualKommentar: null,
    modalSave: false,
    myDetail: null,
    myId: null,
    updateStatus: false,
    kommentsFromDb: null,
    succi: false,
    go: false,
    actualLeistung: null,
    reply: null,
    company: null,
    logo: null,
    renderComponent: false,
    suppliers: [],
    fullTimeline: [],
    email: '',
    puffer: null,
    openMail: false,
    editor: new Editor({
      content: '',
      extensions: [
        StarterKit,
        Underline,
        Link.configure({
          openOnClick: false,
          })
      ],
    }),
    form: {
      client_name: null,
      lang: 'en',
      email: null,
      cc_email: null,
      reply_email: '',
      sender_name: null,
      supplier: 999999999,
      supplier_gender: null,
    },
    tripDetails: {
      travelers: [],
      shuttles: [],
      hotels: [],
      activities: [],
      rental_cars: [],
      flights: [],
    },
    tripSaved: false,
    sending: false,
    accoDetails: [],
    accoDetailsEn: [],
    accoLanguage: [],
    accoCheck: 0,
    autoSelectedOnce: false,
    selectedIndexesByTab: {
      flights: null,
      carRentals: null,
      hotels: null,
      activites: null,
      transport: null,
    },
  }),
  validations: {
    form: {
      email: {required},
      reply_email: {required},
      sender_name: {required},
    }
  },
  created() {
  },
  updated(){
    if(this.leistungaktiv == false){
      let button = document.getElementById("sendButton")
      button.setAttribute("disabled", true)
    }else{
      let button = document.getElementById("sendButton")
      button.removeAttribute("disabled")
    }
  },
  async mounted() {
    this.options.successMsg = "Erfolgreich";
    this.trip = this.currentTrip;
    this.trip_details_json = await this.loadJsonField('trip_details', this.trip.json_path);
    this.getGlobalInfo();
    this.getAccoDetails();
    this.setDefaultTab();
  },
  computed: {
    safeFlights() {
      return Array.isArray(this.tripDetails?.flights) ? this.tripDetails.flights : [];
    },
    safeShuttles() {
      return Array.isArray(this.tripDetails?.shuttles) ? this.tripDetails.shuttles : [];
    },
    safeHotels() {
      return Array.isArray(this.tripDetails?.hotels) ? this.tripDetails.hotels : [];
    },
    safeActivities() {
      return Array.isArray(this.tripDetails?.activities) ? this.tripDetails.activities : [];
    },
    safeRentalCars() {
      return Array.isArray(this.tripDetails?.rental_cars) ? this.tripDetails.rental_cars : [];
    }
  },
  watch: {
    currentTrip: {
      handler(newValue) {
        //console.log(newValue, "NEW VALUE");
        if (newValue) {
          //console.log(newValue);
          //console.log(this.options.tripFormEditable);
          let self = this;
          self.trip = newValue ? newValue : null;
          self.form.id = newValue ? newValue.id : null;
          self.form.client_name = newValue ? newValue.client_name : null;
          self.getTripDetails()
          self.getAccoDetails()
        }
      },
      deep: true,
      immediate: true,
    },
    tabChoice(newVal) {
      // whenever the active tab changes, select the first item of that tab
      this.$nextTick(() => {
        this.selectFirstItemForCurrentTab();
      });
    }
  },
  methods: {
    async loadJsonField(key) {
      const trip = this.currentTrip ? this.currentTrip : null;
      const jsonPath = trip.json_path;

      const payload = {
        data: {
          file_path: jsonPath,
          key: key
        }
      };

      let self = this;

      return new Promise(resolve => {
        this.doPost(payload, 'json/findFieldInJsonFile', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
            return resolve(null);
          }
          resolve(res.data.value);   // return extracted JSON field
        });
      });
    },
    setDefaultTab() {
      console.log(this.tripDetails, "TRIPDETAILS")
      if (this.safeFlights.length) this.tabChoice = 'flights';
      else if (this.safeRentalCars.length) this.tabChoice = 'carRentals';
      else if (this.safeHotels.length) this.tabChoice = 'hotels';
      else if (this.safeActivities.length) this.tabChoice = 'activites';
      else if (this.safeShuttles.length) this.tabChoice = 'transport';

      // after deciding default tab, auto-select first item if possible
      this.$nextTick(() => {
        this.selectFirstItemForCurrentTab();
      });
    },
    clearTripdetails() {
      this.tripDetails = {
        travelers: [],
        shuttles: [],
        hotels: [],
        activities: [],
        rental_cars: [],
        flights: [],
      };
    },
    removeDuplicates() {
      //accodetails
      const result = this.tripDetails.hotels.filter(
        (thing, index, self) =>
          index === self.findIndex((t) => t.name === thing.name)
      );
      this.tripDetails.hotels = result;
      //console.log(this.tripDetails.hotels, "hotels")

    },
    showKommentar(){
      this.modalSave = false;
    },
    changeBackgroundColor(){
      this.backgroundColor = "blue";
    },
    async kommentareToTripDetails() {
      if (Array.isArray(this.tripDetails.travelers)) {
        this.tripDetails.travelers.forEach(element => {
          for (let i = 0; i < this.kommentsFromDb.length; i++) {
            if (element.compID == this.kommentsFromDb[i].comp_id) {
              element.kommentar = this.kommentsFromDb[i].text;
            }
          }
        });
      }
      if (Array.isArray(this.tripDetails.shuttles)) {
        this.tripDetails.shuttles.forEach(element => {
          for (let i = 0; i < this.kommentsFromDb.length; i++) {
            if (element.compID == this.kommentsFromDb[i].comp_id) {
              element.kommentar = this.kommentsFromDb[i].text;
            }
          }
        });
      }
      if (Array.isArray(this.tripDetails.activities)) {
        this.tripDetails.activities.forEach(element => {
          for (let i = 0; i < this.kommentsFromDb.length; i++) {
            if (element.compID == this.kommentsFromDb[i].comp_id) {
              element.kommentar = this.kommentsFromDb[i].text;
            }
          }
        });
      }
      if (Array.isArray(this.tripDetails.hotels)) {
        this.tripDetails.hotels.forEach(element => {
          for (let i = 0; i < this.kommentsFromDb.length; i++) {
            if (element.compID == this.kommentsFromDb[i].comp_id) {
              element.kommentar = this.kommentsFromDb[i].text;
            }
          }
        });
      }
      if (Array.isArray(this.tripDetails.flights)) {
        this.tripDetails.flights.forEach(element => {
          for (let i = 0; i < this.kommentsFromDb.length; i++) {
            if (element.compID == this.kommentsFromDb[i].comp_id) {
              element.kommentar = this.kommentsFromDb[i].text;
            }
          }
        });
      }
      if (Array.isArray(this.tripDetails.rental_cars)) {
        this.tripDetails.rental_cars.forEach(element => {
          for (let i = 0; i < this.kommentsFromDb.length; i++) {
            if (element.compID == this.kommentsFromDb[i].comp_id) {
              element.kommentar = this.kommentsFromDb[i].text;
            }
          }
        });
      }
      this.removeDuplicates();
      this.loaded = true;

      // when comments are merged and loaded, auto-select first item once
      if (!this.autoSelectedOnce) {
        this.$nextTick(() => {
          this.selectFirstItemForCurrentTab();
          this.autoSelectedOnce = true;
        });
      }
    },
    onTabChange(tabKey) {
      // guard against clicking disabled tabs
      const hasItemsMap = {
        flights: this.safeFlights.length,
        carRentals: this.safeRentalCars.length,
        hotels: this.safeHotels.length,
        activites: this.safeActivities.length,
        transport: this.safeShuttles.length,
      };
      if (!hasItemsMap[tabKey]) return;

      if (this.tabChoice === tabKey) return;
      this.tabChoice = tabKey;
      // selectFirstItemForCurrentTab will be called by tabChoice watcher
    },
    getCurrentTabList() {
      switch (this.tabChoice) {
        case 'flights':
          return this.safeFlights;
        case 'carRentals':
          return this.safeRentalCars;
        case 'hotels':
          return this.safeHotels;
        case 'activites':
          return this.safeActivities;
        case 'transport':
          return this.safeShuttles;
        default:
          return [];
      }
    },
    selectFirstItemForCurrentTab() {
      if (!this.loaded || this.modalSave) return;

      const list = this.getCurrentTabList();
      if (!Array.isArray(list) || !list.length) return;

      const firstItem = list[0];
      // build a stable id similar to EventComments buildId
      const baseId = firstItem?.compID || firstItem?.id || 'auto-0';
      const compId = `dattl-${baseId}`;

      // store selected index for this tab so EventComments highlights it
      this.selectedIndexesByTab[this.tabChoice] = 0;

      this.checkSaveKommentar(firstItem, compId);
    },
    checkSaveKommentar(detail, id){
      this.leistungaktiv = true
      // after a successful change, sync the selected index for the current tab
      const list = this.getCurrentTabList();
      const idx = list ? list.indexOf(detail) : -1;
      if (idx !== -1) {
        this.selectedIndexesByTab[this.tabChoice] = idx;
      }

      if(this.checkDetail != null){
        if(this.checkDetail.kommentar != this.editor.getHTML() && this.editor.getHTML() != '<p></p>'){
          this.myDetail = detail;
          this.myId = id;
          this.modalSave = true;
        }else{
          this.detailsForLeistung(detail, id)
        }
      }else{
        this.detailsForLeistung(detail, id)
      }
    },
    detailsForLeistung(detail, id){
      this.options.successMsg = "Erfolgreich";
      this.modalSave = false;

      this.currentComp = detail.compID
      this.actualKommentar = detail.kommentar != null ? detail.kommentar : '';
      this.checkDetail = detail
      

      //this.editor.commands.setContent(this.currentComp);
      this.updateStatus = detail.kommentar == null || detail.kommentar == "<p></p>" ?  true : false
      //console.log(detail, "detail for klick")


      this.editor.commands.setContent(detail.kommentar != null ? detail.kommentar : '');
      //alert(this.updateStatus)
      //this.getKommentare();

      let divs = document.querySelectorAll(".einzelLeistung");

      divs.forEach(element => {
        element.style.backgroundColor = "white";
      })
/*      document.getElementById(id).style.backgroundColor = "lightgrey";*/

      this.actualLeistung = detail.name;
      
    },
    closeDialog() {
      //alert("hallo")
      this.options.currentTrip = null;
      this.options.showaddKommentarForm = false;
    },
    async getGlobalInfo(){
      let self = this;
      await this.doPost({}, 'getglobalinfo', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data[0];
        self.company = result.adresse;
        self.reply = result.reply;
        self.logo = result.baseLogo;
      }    
    });
    },
    async getAccoDetails() {
      const accoDetails = await this.loadJsonField("accommodations_details");
      const accoDetailsEn = await this.loadJsonField("accommodations_details_en");

      this.accoDetails =  accoDetails ;
      this.accoDetailsEn = accoDetailsEn ;
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    async save() {
      this.options.successMsg = "Erfolgreich";
      this.modalSave = false;
      let saveData = {
        tripId: this.trip.nezasa_id,
        compId: this.currentComp,
        text: this.editor.getHTML()
      }
      //console.log(saveData, "saveData")
      if(this.updateStatus == false){
        let self = this;
      await this.doPost({data: saveData}, 'updateKommentar', function (res) {
         if (res.data.status === 'error') {
           self.help.log(self.$t(res.msg), false, true);
         } else {
            //alert("fertig?!")
            self.options.successMsg = self.options.Lang == self.options.German ? "Die Aktion wurde erfolgreich ausgeführt." : "The action was accomplished successfully.";
            self.options.showSuccess = true;

         }
       });
      }
      if(this.updateStatus == true){
        let self = this;
      await this.doPost({data: saveData}, 'saveKommentar', function (res) {
         if (res.data.status === 'error') {
           self.help.log(self.$t(res.msg), false, true);
         } else {
            //alert("fertig?!")
            self.options.successMsg = self.options.Lang == self.options.German ? "Die Aktion wurde erfolgreich ausgeführt." : "The action was accomplished successfully.";
            self.options.showSuccess = true;

         }
       });
      }
      await this.setPdfStatus();
      await this.getKommentare();
     
    },
    async setPdfStatus(){
      // console.log("pdf-status")
      let data = {
        tripId : this.trip.nezasa_id,
        status : "false"
      }
      await this.doPost({ data: data }, 'setStatusPdf', function (res) {
            if (res.data.status === 'error') {
              self.help.log(self.$t(res.msg), false, true);
            } else {
              let result = res.data.data
            }
          });
    },
    async getKommentare(){
      this.loaded = false;
      let saveData = {
        tripId: this.trip.nezasa_id,
      }
      let self = this;
      await this.doPost({data: saveData}, 'getKommentare', function (res) {
         if (res.data.status === 'error') {
           self.help.log(self.$t(res.msg), false, true);
         } else {
           self.kommentsFromDb = Array.isArray(res.data.data) ? res.data.data : [];
         }
       });
       await self.kommentareToTripDetails();
    },
    async getTripDetails() {
      this.clearTripdetails()
      await this.getAccoDetails()
      let self = this;
      self.accoCheck = 0;

      
      await this.doPost({data: self.trip.nezasa_id}, 'getItineraryById', function (res) {
         if (res.data.status === 'error') {
           self.help.log(self.$t(res.msg), false, true);
         } else {
          let result = res.data.data[0].itinerary_details;
          self.itiDetails = JSON.parse(result)
         }
       });

      const _trip = self.form.lang === 'en' ? await this.loadJsonField("trip_details_en") : await this.loadJsonField("trip_details")
      const _travelers = _trip.data.attributes.pax.paxInfo
      const _iti = self.itiDetails;
      let shuttleCheck = 0;
      _iti.itinerary?.modules?.forEach(module => {
        module.legs?.forEach((t, i) => {
          if(t.connections) {
            const tripDetails = t.connections[0]
            if (tripDetails.transferType == 'Shuttle' || tripDetails.transferType == 'Flight') {
              if (shuttleCheck == 0) {
                self.tripDetails.shuttles.push({
                  shuttle: true,
                  pureName: "",
                  name: self.options.Lang == self.options.German ? "Transportinformationen" : "Transport information",
                  duration: "",
                  vendor: '',
                  dayStart: "",
                  dayEnd: "",
                  class: "",
                  airline: "",
                  code: "",
                  check: 0,
                  compID: "SHUTTLEINFO",
                  kommentar: null
                })
                shuttleCheck = 1
              }
            }
          }
        })
      })
      
      await _travelers.forEach((t, i) => {
        self.tripDetails.travelers.push({
          name: t.firstName + ' ' + t.lastName,
          gender: t?.gender ?? 'unknown',
          birthday: moment(t.birthDate).format('DD. MM. YYYY'),
        })
      })

      let flugCheck = 0;
      await _trip.included.forEach((t, i) => {
        const tripDetails = t.attributes
        
        let compID = t.id;
        // console.log(tripDetails.type, "TYPE");
        
        switch (tripDetails.type) {
          case 'internationalFlight' :

          if(flugCheck == 0) {
            // console.log(tripDetails, "DETAIL")
              // console.log(compID)
              self.tripDetails.flights.push({
                flight: true,
                pureName:"",
                name: self.options.Lang == self.options.German ? "Fluginformationen" : "Flight information",
                duration: "",
                vendor: '',
                dayStart: "",
                dayEnd: "",
                class: "",
                airline: "",
                code: "",
                check: 0,
                compID: "FLUGINFO",
                kommentar: null
              })
              flugCheck = 1
          }
          break;
            
          case 'accommodation' :
          //console.log(compID)
          if(self.form.lang === 'en'){
            self.accoLanguage = self.accoDetailsEn;
          }else{
            self.accoLanguage = self.accoDetails;
          }
          let acco_loop = self.accoLanguage
          if(self.accoLanguage.accommodations){
            acco_loop = self.accoLanguage.accommodations
          }
          acco_loop.forEach(element =>{
            if(element.attributes?.amenities)
            {
              element.attributes.amenities.forEach(ane =>[
                ane.longDescription = ""
              ])
            }else if(element.amenities){
              element.amenities.forEach(ane =>[
                ane.longDescription = ""
              ])
            }
          })
          //console.log(self.accoLanguage, "SEEEEEEEEEEEEEEEEEEEEEEEEEEEEELLFFFFF")
             self.tripDetails.hotels.push({
              compID: compID,
              pureName: tripDetails.productName || tripDetails.desc,
              desc: tripDetails.desc,
              name: moment.parseZone(tripDetails.startDateTime).format('DD. MMM YYYY') + ' - ' + moment.parseZone(tripDetails.endDateTime).format('DD. MMM YYYY') + ' ' + tripDetails.desc,
              vendor: tripDetails?.supplier?.name ? tripDetails.supplier.name : tripDetails?.supplier?.id,
              check: 0,
              zusatz: self.accoLanguage[self.accoCheck]?.attributes?.amenities ? self.accoLanguage[self.accoCheck].attributes.amenities : self.accoLanguage[self.accoCheck]?.amenities ? self.accoLanguage[self.accoCheck].amenities : '',
              kommentar: null
            })
            this.accoCheck++;
            break;
          case 'activity' :
          //console.log(compID)
            self.tripDetails.activities.push({
              compID: compID,
              name: tripDetails.desc,
              pureName: tripDetails.desc,
              date: moment.parseZone(tripDetails.startDateTime).format('DD. MMM YYYY HH:mm') + ' - ' + moment.parseZone(tripDetails.endDateTime).format('DD. MMM YYYY HH:mm'),
              vendor: tripDetails?.supplier?.name ? tripDetails.supplier.name : tripDetails?.supplier?.id,
              check: 0,
              kommentar: null
            })
            break;
          case 'rental-car' :
          //console.log(compID)
            self.tripDetails.rental_cars.push({
              compID: compID,
              pureName: tripDetails.desc,
              name: tripDetails.desc + ' ' + ( tripDetails?.acriss?.transmissionCode === 'M' ? 'Manuell' : 'Automatik'),
              date: moment.parseZone(tripDetails.pickupDate).format('DD. MMM YYYY HH:mm') + ' ' + tripDetails.pickupLocation + ' - ' + moment.parseZone(tripDetails.dropoffDate).format('DD. MMM YYYY HH:mm') + ' ' +  tripDetails.dropoffLocation,
              vendor: tripDetails?.supplier?.name ? tripDetails.supplier.name : tripDetails?.supplier?.id,
              check: 0,
              kommentar: null
            })
            break;
          default: console.log("default")
        }
        // console.log(self.tripDetails.flights, "flights")
      })
      await this.getKommentare();
      this.setDefaultTab();
    },
  
   
    openDialog() {

    },
    validate() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.save()
      }
    },
    moment(date){
      return moment(date)
    }
  }
}
</script>

<style lang="scss">
@use '../../assets/style/FormAddKommentar/main.scss';
@use '../../assets/style/FormAddKommentar/tab_layout.scss';
@use '../../assets/style/General/animations/fadeTransition.scss';
</style>